'use client'
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { CircularProgress, Box } from "@mui/material";
import VerifyEmailCodePage from "app/Pages/VerifyEmailCodePage";
import { RootState } from "store";

const RootContainer = styled("div")({
  minHeight: "70vh",
  margin: "auto",
});

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const user = useSelector((state: RootState) => state.user.user);

  // If no user, redirect to login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // If user exists but email not verified, show verification page
  if (user && !user.emailVerified) {
    return <RootContainer><VerifyEmailCodePage /></RootContainer>;
  }

  // User is authenticated and verified, show the protected content
  return <RootContainer>{children}</RootContainer>;
}

export default ProtectedRoute;
